import TWSkeleton from "components/utilities/TWSkeleton";
export const BookingPriceLoading = ({
  className = ""
}: {
  className?: string;
}) => {
  return <div className={`animate-pulse rounded-[8px] bg-white p-6 ${className}`} data-sentry-component="BookingPriceLoading" data-sentry-source-file="BookingPriceLoading.tsx">
      <div className='flex flex-col gap-4'>
        <div className='flex items-start justify-between gap-4'>
          <div className='flex flex-col gap-3'>
            <TWSkeleton className='h-4 w-20 rounded-lg' data-sentry-element="TWSkeleton" data-sentry-source-file="BookingPriceLoading.tsx" />
            <TWSkeleton className='h-7 w-36 rounded-lg' data-sentry-element="TWSkeleton" data-sentry-source-file="BookingPriceLoading.tsx" />
          </div>
          <TWSkeleton className='mt-1 h-4 w-28 rounded-lg' data-sentry-element="TWSkeleton" data-sentry-source-file="BookingPriceLoading.tsx" />
        </div>
        <div className='h-[1px] w-full bg-Gray-200' />
        <div className='flex flex-col gap-3'>
          <TWSkeleton className='h-4 w-32 rounded-lg' data-sentry-element="TWSkeleton" data-sentry-source-file="BookingPriceLoading.tsx" />
          <div className='flex items-center justify-between gap-3'>
            <TWSkeleton className='h-4 w-32 rounded-lg' data-sentry-element="TWSkeleton" data-sentry-source-file="BookingPriceLoading.tsx" />
            <TWSkeleton className='h-4 w-14 rounded-lg' data-sentry-element="TWSkeleton" data-sentry-source-file="BookingPriceLoading.tsx" />
          </div>
          <div className='flex items-center justify-between gap-3'>
            <TWSkeleton className='h-4 w-24 rounded-lg' data-sentry-element="TWSkeleton" data-sentry-source-file="BookingPriceLoading.tsx" />
            <TWSkeleton className='h-4 w-12 rounded-lg' data-sentry-element="TWSkeleton" data-sentry-source-file="BookingPriceLoading.tsx" />
          </div>
        </div>
        <TWSkeleton className='h-11 w-full rounded-[10px]' data-sentry-element="TWSkeleton" data-sentry-source-file="BookingPriceLoading.tsx" />
        <TWSkeleton className='h-11 w-full rounded-[10px]' data-sentry-element="TWSkeleton" data-sentry-source-file="BookingPriceLoading.tsx" />
      </div>
    </div>;
};